import { Alert, Button, Space, Spin, Tooltip, Typography } from 'antd'
import { ReloadOutlined } from '@ant-design/icons'
import TurnstileWidget from './TurnstileWidget'
import type { useEmailCodeVerification } from '../../hooks/useEmailCodeVerification'

interface EmailCodeVerificationProps {
  verification: ReturnType<typeof useEmailCodeVerification>
}

export default function EmailCodeVerification({ verification }: EmailCodeVerificationProps) {
  if (!verification.siteKey) return null

  return (
    <div data-testid="email-code-verification" style={{ marginBottom: 16, width: '100%', minWidth: 0 }}>
      {verification.sending ? (
        <Space role="status" style={{ minHeight: 64 }}>
          <Spin size="small" />
          <Typography.Text>正在發送驗證碼</Typography.Text>
        </Space>
      ) : verification.completed ? (
        <Alert
          type="success"
          showIcon
          message="人機驗證已完成"
          action={
            <Tooltip title="重新驗證以再次獲取驗證碼">
              <Button type="text" icon={<ReloadOutlined />} aria-label="重新驗證" onClick={verification.reset} />
            </Tooltip>
          }
        />
      ) : (
        <TurnstileWidget
          ref={verification.widgetRef}
          siteKey={verification.siteKey}
          action="email_code"
          onTokenChange={verification.setToken}
          onErrorChange={verification.setError}
        />
      )}
      {verification.error && (
        <Alert type="error" showIcon message={verification.error} style={{ marginTop: 8 }} />
      )}
    </div>
  )
}
